import { z as zod } from 'zod';
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";
import { ComponentIntroHero, ComponentIntroHeroInput, UploadFile } from "@/app/lib/generated/graphql-types";
import { notNull } from "@/app/lib/common/not-null";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { getUploadFileId } from "@/app/lib/common/get-image-id";

export const HeroIntroSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, { message: 'Titel fehlt' }),
    subtitle: zod.string().nullish(),
    description: zod.string().nullish(),
    links: zod.array(LinkSchema),
    image: MediaRefSchema,
});

export type HeroIntroEditable = zod.infer<typeof HeroIntroSchema>;

export function editableHeroIntroFrom(heroIntro: ComponentIntroHero): HeroIntroEditable {
    return {
        id: heroIntro.id,
        title: heroIntro.title,
        subtitle: heroIntro.subtitle,
        description: heroIntro.description,
        image: heroIntro.image,
        links: heroIntro.links?.filter(notNull) ?? []
    };
}

export async function heroIntroInputFrom(editableHeroIntro: HeroIntroEditable): Promise<ComponentIntroHeroInput> {
    return {
        title: editableHeroIntro.title,
        subtitle: editableHeroIntro.subtitle,
        description: editableHeroIntro.description,
        image: await getUploadFileId(editableHeroIntro.image as UploadFile),
        links: editableHeroIntro.links.map(link => ({
            ...link,
            id: link.id || ''
        }))
    };
}